import { http } from './Connect';
import { buildUrl } from '@/helpers/buildUrl';

/**
 * Get underground casino games.
 * @param operatorId operator id.
 */

export async function getUndergroundCasinoGames(
  operatorId: number
): Promise<any> {
  return http.post(
    buildUrl(`api/v1/app/control/${operatorId}/streamer/game/synchronize`)
  );
}
